import { LitElement } from '~/lib/bn-lit-element';
import { html, renderIf } from '../utility/lit-entity';
import { bannerStyles } from '../styles/banner-styles';
import './bn-loading';

const LOADER_WAIT_MS = 100;

class BnDynamicallyImported extends LitElement {
  static get properties() {
    return {
      suppressloading: { type: Boolean },
      elementLoaded: { type: Boolean, attribute: false },
      displayLoading: { type: Boolean, attribute: false },
      wrongNumberOfElements: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return bannerStyles;
  }

  render() {
    if (this.wrongNumberOfElements) {
      return html`
        <div class="banner banner--critical">
          <code>Error: &lt;bn-dynamically-imported&gt; must be used with exactly 1 slotted tag element, 0 found.</code>
        </div>
      `;
    }

    const showLoadingSpinner = !this.suppressloading && this.displayLoading && !this.elementLoaded;
    return html`
      ${renderIf(showLoadingSpinner, html`<bn-loading></bn-loading>`)}
      <slot @slotchange="${() => this._onSlotChange()}"></slot>
    `;
  }

  async _onSlotChange() {
    const slottedTags = this.getElementsByTagName('*');
    if (slottedTags.length < 1) {
      this.wrongNumberOfElements = true;
      return;
    }

    if (slottedTags.length > 1) {
      // eslint-disable-next-line no-console
      console.warn(`bn-dynamically-imported should be used with exactly 1 slotted tag, got ${slottedTags.length}`);
    }

    const foundTag = slottedTags[0];
    if (foundTag.tagName.toLowerCase() === 'slot') {
      // This is an edge issue where the <slot> is sometimes not replaced in this elements context
      this.suppressloading = true;
      return;
    }

    this.elementLoaded = !!window.customElements.get(foundTag.tagName);
    if (this.elementLoaded) {
      return;
    }

    setTimeout(() => {
      this.displayLoading = true;
    }, LOADER_WAIT_MS);

    await window.customElements.whenDefined(foundTag.tagName.toLowerCase());
    this.elementLoaded = true;
  }
}

window.customElements.define('bn-dynamically-imported', BnDynamicallyImported);
